import React from "react";
import { Regular4Style } from "./css/Regular4Style";
import OutroLogo from "../../components/editor/Templates/OutroLogo";
import OutroText from "../../components/editor/Templates/OutroText";

const regular_4 = (props) => {
  return (
    <Regular4Style>
      <div className="poster flex-column">
        <div className="poster-content">
          <div className="logo-container flex-column">
            <OutroLogo logo={props.file} />
          </div>
          <div className="text-wrapper flex-column">
            <OutroText
              id={props.id}
              text={props.text}
              textStyle={props.textStyle}
              editStatus={props.editStatus}
              onInputSlideText={props.onInputSlideText}
            />
          </div>
        </div>
      </div>
    </Regular4Style>
  );
};

export default regular_4;
